export { ComoReceber as A6AdmDonationReceivement } from "./ComoReceber"
export * from "./mount"
